import { withProps } from 'recompose'
import {
  BADGE_TYPE_MAP,
  GENERIC_WARRANTY_NAME,
  MANUFACTURERS_LIMITED_WARRANTY,
  MANUFACTURER_TOOLTIP_MESSAGE,
  TPP_TOOLTIP_MESSAGE
} from './constants'
import {
  getDisplayName,
  getWarrantyValueForBadge,
  isMileageWarranty,
  isTreadLifeWarranty,
  getMileageWarrantyTooltipMsg
} from './helpers'
import { BIG_O_MILEAGE_WARRANTY, MANUFACTURER_MILEAGE_WARRANTY } from 'constant'

import WarrantyBadge from './WarrantyBadge'
import WarrantyBadgeTitleView from './WarrantyBadgeTitle'

const withWarrantyBadgeProps = withProps(({
  warranty,
  name,
  height,
  small
}) => ({
  treadLifeWarrantyValue: isTreadLifeWarranty(warranty) && getWarrantyValueForBadge(warranty),
  asset: BADGE_TYPE_MAP[name || MANUFACTURER_MILEAGE_WARRANTY],
  isTreadLife: isMileageWarranty({ name, value: warranty }),
  height: small ? '44px' : (height || '60px'),
  width: small ? '44px' : (height || '60px')
}))

const withTitleProps = withProps(({
  value,
  name,
  short,
  long
}) => {
  const isBigOWarranty = name === BIG_O_MILEAGE_WARRANTY
  const isTireProtectionPackage = !isBigOWarranty
  const isLimitedWarranty = isBigOWarranty && !isMileageWarranty({ name, value })
  const title = isLimitedWarranty ?
    (long ? MANUFACTURERS_LIMITED_WARRANTY : GENERIC_WARRANTY_NAME) :
    getDisplayName({ name, short, long })

  return ({
    isLimitedWarranty,
    isTireProtectionPackage,
    name: title,
    toolTipMessage: isTireProtectionPackage
      ? TPP_TOOLTIP_MESSAGE : isLimitedWarranty
        ? MANUFACTURER_TOOLTIP_MESSAGE : getMileageWarrantyTooltipMsg(value)
  })
})

export const WarrantyBadgeTitle = withTitleProps(WarrantyBadgeTitleView)

export default withWarrantyBadgeProps(WarrantyBadge)

